var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7836 3.41667V3.51667H13.8836H17.4392C17.6484 3.51667 17.8491 3.59978 17.997 3.74773C18.145 3.89567 18.2281 4.09633 18.2281 4.30556V14.9722V15.0722H18.3281H20.0058V16.65H0.650293V15.0722H2.32807H2.42807V14.9722V4.30556C2.42807 4.09633 2.51119 3.89567 2.65913 3.74773C2.80708 3.59978 3.00773 3.51667 3.21696 3.51667H6.77252H6.87252V3.41667V1.63889C6.87252 1.42966 6.95563 1.22901 7.10358 1.08106C7.25152 0.933115 7.45218 0.85 7.6614 0.85H12.9947C13.204 0.85 13.4046 0.933115 13.5526 1.08106C13.7005 1.22901 13.7836 1.42966 13.7836 1.63889V3.41667ZM6.87252 5.19444V5.09444H6.77252H4.10585H4.00585V5.19444V14.9722V15.0722H4.10585H6.77252H6.87252V14.9722V5.19444ZM12.2058 5.19444V5.09444H12.1058H8.55029H8.45029V5.19444V14.9722V15.0722H8.55029H12.1058H12.2058V14.9722V5.19444ZM16.6503 5.19444V5.09444H16.5503H13.8836H13.7836V5.19444V14.9722V15.0722H13.8836H16.5503H16.6503V14.9722V5.19444ZM12.2058 2.52778V2.42778H12.1058H8.55029H8.45029V2.52778V3.41667V3.51667H8.55029H12.1058H12.2058V3.41667V2.52778Z",
    fill: "#088E25",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon15);
export default __webpack_public_path__ + "static/media/icon-15.869666c0eb117bfea8c08343644cf192.svg";
export { ForwardRef as ReactComponent };